import React from 'react';
import {Chip, Stack, Tooltip} from '@mui/material';
import {useIRPWorkbookStore} from '../../../../../../stores/irp-workbook.store';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

const DataSummary: React.FC = () => {
    const eventSequenceData = useIRPWorkbookStore((state) => state.eventSequenceData);

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <Tooltip title={eventSequenceData ? 'Safety View ready' : 'Safety View not loaded'}>
                <Chip
                    icon={eventSequenceData ? <CheckCircleIcon /> : <AccountTreeIcon />}
                    label="Safety View"
                    size="small"
                    color={eventSequenceData ? 'success' : 'default'}
                    variant={eventSequenceData ? 'filled' : 'outlined'}
                    sx={{ height: 24, fontSize: '0.7rem' }}
                />
            </Tooltip>
        </Stack>
    );
};

export default DataSummary;
